var _path, _g, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatCourses = function SvgStatCourses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.083 16.043V4.475c0-1.15-.939-2.002-2.08-1.907h-.057c-2.012.173-5.07 1.198-6.775 2.272l-.163.105c-.278.173-.738.173-1.016 0l-.24-.144C9.048 3.738 6 2.721 3.988 2.56a1.885 1.885 0 0 0-2.07 1.907v11.576c0 .92.747 1.783 1.667 1.898l.278.038c2.08.278 5.29 1.332 7.13 2.339l.038.019c.26.144.671.144.92 0 1.84-1.016 5.06-2.08 7.15-2.358l.316-.038c.92-.115 1.667-.978 1.667-1.898Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "M11.5 5.261v14.375V5.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.5 5.261v14.375"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "M7.427 8.136H5.271h2.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.427 8.136H5.271"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.146 11.011H5.27",
    opacity: 0.4
  })));
};
export default SvgStatCourses;